export default [

     {
          path: '/configration-grade',
          name: 'ConfigrationGrade',
          component: () => import("@/views/Page/ConfigrationGrade/ConfigrationGrade.vue"),
          meta: {
               title: 'Configration Grade',
          },
     }
];